// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2EcV2","list":"BalanceDue_list__3aetd","listRow":"BalanceDue_listRow__1g2bn","total":"BalanceDue_total__2Xh_1"};